/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_External_Directories_LoadingInputs */

const en_directory_external_directories_loading = /** @type {(inputs: Directory_External_Directories_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading catalog…`)
};

const zh_directory_external_directories_loading = /** @type {(inputs: Directory_External_Directories_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载目录中…`)
};

/**
* | output |
* | --- |
* | "Loading catalog…" |
*
* @param {Directory_External_Directories_LoadingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_external_directories_loading = /** @type {((inputs?: Directory_External_Directories_LoadingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_External_Directories_LoadingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_external_directories_loading(inputs)
	return zh_directory_external_directories_loading(inputs)
});
export { directory_external_directories_loading as "directory.external_directories.loading" }